import React, { useEffect } from 'react';

import EventTracking from 'lib/EventTracking';

import BoxBody from 'components/BoxBody';
import Button from 'components/Button';
import Divider from 'components/Divider';
import Heading from 'components/Heading';
import Row from 'components/Row';
import Text from 'components/Text';

type Props = {
  onClickBookSession: () => void;
  isInstance?: boolean;
  eventPrefix?: string;
};

export default function ConfirmCancelledRecurringSessionOrInstance({
  onClickBookSession,
  isInstance,
  eventPrefix,
}: Props) {
  const eventPrefixWithCoachingSessionType = isInstance
    ? `${eventPrefix}.cancel_session_confirmation`
    : `${eventPrefix}.cancel_plan_confirmation`;

  function trackKey(key: string) {
    eventPrefix && EventTracking.trackKey(`${eventPrefixWithCoachingSessionType}.${key}`);
  }

  useEffect(() => {
    trackKey('view');
  }, []);

  return (
    <>
      <BoxBody size="xsmall">
        <Row size="xsmall">
          <Heading level="2">Your {isInstance ? 'session' : 'plan'} is cancelled</Heading>
        </Row>
        <Row size="xsmall">
          <Text>A confirmation has also been emailed to you for your records.</Text>
        </Row>
        <Divider size="medium" />
        <Row size="xsmall">
          <Heading level="4">
            <Text weight="normal">Add a session any time</Text>
          </Heading>
        </Row>
        <Row size="small">
          <Text>
            Whether you’re preparing for a test or need some extra help, you can book a new session
            whenever you need it.
          </Text>
        </Row>
        <Button
          eventKey={eventPrefix && `${eventPrefixWithCoachingSessionType}.add_new_session.click`}
          full
          onClick={onClickBookSession}>
          Add new session
        </Button>
      </BoxBody>
    </>
  );
}
